import { defineChain } from "viem";
import { http, createConfig, cookieStorage, createStorage } from "wagmi";
import { bsc, bscTestnet } from "wagmi/chains";

export const polygonAmoyTest = /*#__PURE__*/ defineChain({
  id: 80002,
  name: "Polygon Amoy",
  nativeCurrency: { name: "POL", symbol: "POL", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.ankr.com/polygon_amoy"],
    },
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://amoy.polygonscan.com",
      apiUrl: "https://api-amoy.polygonscan.com/api",
    },
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 3127388,
    },
  },
  testnet: true,
});

const testnetChains = [
  bscTestnet,
  // polygonAmoy,
  // polygonAmoyTest,
  // goerli,
] as const;

const testnetTransports = {
  [bscTestnet.id]: http(
    "https://site1.moralis-nodes.com/bsc-testnet/c91a683cd0bd4503ab4e09f8f8a77ba2"
  ),
  // [polygonAmoy.id]: http(),
  // [polygonAmoyTest.id]: http(),
  // [goerli.id]: http(),
} as const;

const mainnetChains = [bsc] as const;
const mainnetTransports = {
  [bsc.id]: http(
    "https://site1.moralis-nodes.com/bsc/e4817b883ea94c25838807de6e7da9be"
  ),
} as const;

const networkEnv = process.env.NEXT_PUBLIC_NETWORK_ENV || "testnet";
// process.env.NODE_ENV === "production" ? "mainnet" : "testnet";

const chainAndTransports = {
  mainnet: { chains: mainnetChains, transports: mainnetTransports },
  testnet: { chains: testnetChains, transports: testnetTransports },
};

declare module "wagmi" {
  interface Register {
    config: ReturnType<typeof getWagmiConfig>;
  }
}

export const getWagmiConfig = () =>
  createConfig({
    ...chainAndTransports[networkEnv as "testnet"],
    ssr: true,
    storage: createStorage({
      storage: cookieStorage,
    }),
  });
